import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20cream%20gradient%20background%20with%20soft%20abstract%20fluid%20shapes%20and%20gentle%20light%20particles%2C%20elegant%20modern%20minimalist%20design%2C%20ethereal%20dreamy%20atmosphere%2C%20soft%20focus%2C%20cinematic%20lighting%2C%20peach%20and%20golden%20tones&width=1600&height=900&seq=hero-bg-mitao&orientation=landscape"
          alt="蜜桃视频 - 精选短视频内容平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          发现精彩，<span className="text-primary-300">记录生活</span>
        </h1>
        <p className="text-background-200 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          蜜桃视频是专注优质短视频内容的创作与分享平台，汇聚海量精彩视频资源，
          涵盖生活、美食、娱乐、创意等多元内容，让每一天都充满灵感与乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/shenghuo"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm cursor-pointer hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm cursor-pointer hover:bg-background-50/30 transition-all duration-300 border border-background-50/30 whitespace-nowrap"
          >
            <i className="ri-user-add-line mr-2"></i>成为创作者
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm text-background-100 text-xs font-medium cursor-pointer hover:bg-background-50/25 transition-all whitespace-nowrap"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}